import { gsap } from "gsap";

class FilteringInterview {
  constructor(el) {
    this.dom = {el: el};
    this.dom.triggers = this.dom.el.querySelectorAll('[data-js="filtering-trigger"]');
    this.dom.targets = this.dom.el.querySelectorAll('[data-js="filtering-target"]');
    this.dom.methods = this.dom.el.querySelector('[data-js="methods"]');
    this.dom.showTarget = null;

    this.filtering = this.filtering.bind(this)

    this.init();
  }

  init() {
    [...this.dom.triggers].forEach(el => {
      el.addEventListener('click', this.filtering)
    });
	}

  filtering(e) {

    let regexp = null;
    this.dom.methods.dataset.state = 'disabled';

    // ボタン選択時
    if (!e.currentTarget.dataset.state) {
      const button = this.dom.el.querySelector('[data-js="filtering-trigger"][data-state="selected"]');
      if (button) button.removeAttribute('data-state')
      e.currentTarget.dataset.state = 'selected';
      regexp = (e.currentTarget.dataset.category === 'career') ? /career/ : /graduate/;
    } else {
      e.currentTarget.removeAttribute('data-state');
      regexp = /graduate|career/;
    }
    
    let targets = null;

    gsap.to(this.dom.targets, {
      opacity: 0,
      scale: .95,
      onComplete: () => {
        // is-showを削除
        [...this.dom.targets].forEach(el => {
          el.classList.remove('is-show')
        })
        // 要素の非表示
        gsap.set(this.dom.targets, {
          display: 'none',
        })

        targets = [...this.dom.targets].filter((target) => {
          return regexp.test(target.dataset.category)
        })

        gsap.to(targets, {
          display: 'block',
          opacity: 1,
          scale: 1,
          onStart: () => {
            [...targets].forEach(el=>{
              el.classList.add('is-show');
            })
          },
          onComplete: () => {
            this.dom.methods.removeAttribute('data-state')
          }
        })
      }
    })
  }
}

export default FilteringInterview